import { CommonModule } from '@angular/common';
import { TextFieldModule } from '@angular/cdk/text-field';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/core/services/auth.service';
import { FormGroup, FormControl, Validators, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { environment } from "@env/environment";
import { ToastService } from '@app/shared/toast/toast.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TextFieldModule,
  ],
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.css']
})
export class ContactPageComponent implements OnInit {

  constructor(
    private http: HttpClient,
    private toast: ToastService,
    private readonly authService: AuthService,
  ) { }

  contactForm = new FormGroup({
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required, Validators.pattern("^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$")]),
    reason: new FormControl('', Validators.required),
    message: new FormControl('', Validators.required)
  });

  failedSubmit = false;
  isSubmitting = false;
  emailLocked = false;

  async ngOnInit(): Promise<void> {
    const email = await this.authService.getAuthenticatedEmail();
    if (email) {
      this.contactForm.controls.email.setValue(email);
      this.contactForm.controls.email.disable();
      this.emailLocked = true;
    }
  }

  async submitForm(_formData: unknown, formDirective: FormGroupDirective) {
    if (!this.contactForm.valid || this.isSubmitting) {
      this.contactForm.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    this.failedSubmit = false;
    const dateTimeStamp = new Date();
    const payload = {
      ...this.contactForm.getRawValue(),
      year: dateTimeStamp.getFullYear(),
      day: dateTimeStamp.getDate(),
      month: dateTimeStamp.getMonth() + 1,
      time: `${dateTimeStamp.getHours()}:${dateTimeStamp.getMinutes()}`,
    };

    try {
      await firstValueFrom(
        this.http.post(environment.API_URL + 'contact-form', payload)
      );
      this.contactForm.reset();
      formDirective.resetForm({ email: this.emailLocked ? payload.email : '' });
      this.toast.success('An agent will reach out soon');
    } catch {
      this.failedSubmit = true;
    } finally {
      this.isSubmitting = false;
    }
  }
}
